module.exports = __webpack_public_path__ + "img/11069858_L.c2084f6a.png";